import Accordion from 'components/Accordion';

import { useIntl } from 'react-intl';
import RecommendationCard from './RecommendationCard';
import type SpeakerRecommendationsProps from './SpeakerRecommendations.props';

const SpeakerRecommendations = ({
  recommendations,
  speakerName
}: SpeakerRecommendationsProps) => {
  const { formatMessage } = useIntl();
  const title = speakerName
    ? formatMessage(
        { defaultMessage: "{speakerName}'s resource list" },
        { speakerName }
      )
    : formatMessage({ defaultMessage: 'More Resources' });

  return (
    <Accordion
      itemStyles="mb-5 bg-gray-300 rounded-sm"
      collapsible
      headerTagName="h3"
      items={[
        {
          content: (
            <div className="pt-3">
              {recommendations[0].recLists.map(recList => {
                return (
                  <div key={recList.title}>
                    {recList.recItems.map((item, index, items) => {
                      return (
                        <RecommendationCard
                          showDivider={index !== items.length - 1}
                          key={item.headline}
                          citation={item.note}
                          title={item.headline}
                          description={item.blurb}
                          label={item.label}
                          linkUrl={item.linkUrl}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
          ),
          title
        }
      ]}
    />
  );
};

export default SpeakerRecommendations;
